import axios from 'axios'

/**
 * 로그인
 * @since 2021.10.06
 * @author kim
 * @version 1.0
 *
 * << 개정 이력 >>
 *
 * 수정일                        수정자                                  수정내용
 * ----------------             ---------------------                   --------------------------------------------------------
 * 2021.10.06                   김효일                                   최초작성
**/
export async function login (form) {
  try {
    return axios.post('/auth/signin', {
      username: form.username,
      uiPw: form.uiPw,
      recaptchaResponse: form.recaptchaResponse
    })
  } catch (error) {
    console.log(error)
  }
}

/**
 * 토큰 재발급
 * @since 2021.10.06
 * @author kim
 * @version 1.0
 *
 * << 개정 이력 >>
 *
 * 수정일                        수정자                                  수정내용
 * ----------------             ---------------------                   --------------------------------------------------------
 * 2021.10.06                   김효일                                   최초작성
**/
export async function reissue (accessToken, refreshToken) {
  try {
    return axios.post('/auth/reissue', {
      accessToken,
      refreshToken
    })
  } catch (error) {
    console.log(error)
  }
}

/**
 * 로그아웃
 * @since 2021.10.06
 * @author kim
 * @version 1.0
 *
 * << 개정 이력 >>
 *
 * 수정일                        수정자                                  수정내용
 * ----------------             ---------------------                   --------------------------------------------------------
 * 2021.10.06                   김효일                                   최초작성
**/
export async function logout (accessToken, refreshToken) {
  try {
    return axios.post('/auth/signout', {
      accessToken,
      refreshToken
    })
  } catch (error) {
    console.log(error)
  }
}

export async function modifyPassword (form) {
  try {
    return axios.post('/modify/password', {
      username: form.username,
      uiPw: form.uiPw,
      newUiPw: form.newUiPw
    })
  } catch (error) {
    console.log(error)
  }
}
